// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Table_tableContainer__1rMyl"};